import { Text, Title } from "@/atoms"
import { Trans } from "@/hooks/useTranslation"

import styles from "./AboutSection.module.scss"

import type { AboutSectionProps } from "./AboutSection.types"

export const AboutSection = ({ section, hasDivider }: AboutSectionProps) => (
  <div className={hasDivider ? styles.withDivider : undefined}>
    <Title level={5} className={styles.title}>
      {section.title}
    </Title>
    <Text>
      <Trans>{section.description}</Trans>
    </Text>
  </div>
)
